(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Parent_Dialog_Handler = (function(superClass) {
    extend(Parent_Dialog_Handler, superClass);

    function Parent_Dialog_Handler() {
      return Parent_Dialog_Handler.__super__.constructor.apply(this, arguments);
    }

    Parent_Dialog_Handler.prototype.init = function() {
      this.classes = 'portal-convert-dialog';
      this.createDialog();
      this.openDialog();
      return this.displayLoadingMessage();
    };

    Parent_Dialog_Handler.prototype.saveStub = function() {};

    Parent_Dialog_Handler.prototype.rowCallback = function(row, data) {};

    Parent_Dialog_Handler.prototype.refreshReport = function() {
      var s;
      this.filters = this.parent.getAppliedFilters();
      s = this.table.dataTable().fnSettings();
      s._iDisplayStart = 0;
      s._iDisplayEnd = s._iDisplayStart + s._iDisplayLength;
      return this.table.dataTable().fnDraw();
    };

    Parent_Dialog_Handler.prototype.afterLoadLayout = function(selector, response) {
      var ref, ths;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      ths = this;
      $(window).unbind('modal_resized').bind('modal_resized', debounce((function(_this) {
        return function(e) {
          var size;
          size = _this.dialog.find('.modal-body').height() - 177;
          _this.table.fnSettings().sY = size + "px";
          $('.dataTables_scrollBody').height(size);
          return _this.table.dataTable().fnAdjustColumnSizing(false);
        };
      })(this)));
      this.filters = this.parent.getAppliedFilters();
      this.msg = this.dialog.find('.message_writer').message_writer();
      if (this.msg.length !== 0) {
        this.msg.message_writer('success', 'Report Finished');
        this.msg.message_writer('hide');
      }
      this.dialog.find('.modal-body').resizr();
      setTimeout((function(_this) {
        return function() {
          return _this.buildTable();
        };
      })(this), 250);
      return this.initializeListeners();
    };

    Parent_Dialog_Handler.prototype.showHideButton = function() {
      if (this.dialog.find('.chk-copy:checked').length) {
        return this.dialog.find('#btn-autofill-actual').show();
      } else {
        return this.dialog.find('#btn-autofill-actual').hide();
      }
    };

    Parent_Dialog_Handler.prototype.buildTable = function() {
      var size;
      if (this.reportAjax == null) {
        this.reportAjax = '';
      }
      size = this.dialog.find('.modal-body').height() - 177;
      this.table = this.dialog.find('.table').dataTable({
        sScrollY: size + "px",
        bDestroy: true,
        bFilter: false,
        bInfo: false,
        bSort: false,
        bPaginate: true,
        bServerSide: true,
        bScrollCollapse: true,
        iDisplayLength: 50,
        sAjaxSource: this.reportAjax,
        sPaginationType: "bootstrap",
        fnServerParams: (function(_this) {
          return function(aoData) {
            return aoData.push({
              name: "query",
              value: ko.toJSON(_this.filters)
            });
          };
        })(this),
        fnInitComplete: function() {
          return this.fnAdjustColumnSizing(true);
        },
        fnRowCallback: (function(_this) {
          return function(row, data) {
            return _this.rowCallback(row, data);
          };
        })(this)
      });
      return this.table.fnDraw();
    };

    Parent_Dialog_Handler.prototype.initializeListeners = function() {
      var ths;
      ths = this;
      this.dialog.find('#chk-autofill').bind('click', function() {
        var chkd;
        chkd = $(this).is(':checked');
        ths.dialog.find('.chk-copy').prop('checked', chkd);
        return ths.showHideButton();
      });
      this.dialog.find('#txt-autofill-percent, #txt-autofill-days').bind('change', function() {
        var val;
        val = $(this).val();
        $(this).val('');
        return ths.dialog.find('.txt-actual-percent, .txt-days').val(val).change();
      });
      this.dialog.on('keyup.convert', '#txt-autofill-percent', function() {
        return $(this).val($(this).val().replace(/[^\d\.]+/g, ''));
      });
      this.dialog.on('keyup.convert', '#txt-autofill-days', function() {
        return $(this).val($(this).val().replace(/[^-^\d]+/g, ''));
      });
      this.dialog.on('keyup.convert', '.txt-actual-acres', function() {
        return $(this).val($(this).val().replace(/[^\d\.]+/g, ''));
      });
      this.dialog.on('keyup.convert', '.txt-actual-pop', function() {
        return $(this).val($(this).val().replace(/[^\d]+/g, ''));
      });
      this.dialog.on('keyup.convert', '.txt-days', function() {
        return $(this).val($(this).val().replace(/[^-^\d]+/g, ''));
      });
      this.dialog.on('keyup.convert', '.txt-actual-percent', function() {
        return $(this).val($(this).val().replace(/[^\d\.]+/g, ''));
      });
      this.dialog.on('change.convert', '.txt-actual-date', function() {
        return $(this).val($(this).val().replace(/[^\d\-\/]+/g, ''));
      });
      this.dialog.find('#btn-autofill-actual').bind('click', function() {
        var elem, i, len, ref;
        ths.dialog.find('#chk-autofill').prop('checked', false);
        ref = ths.dialog.find('.chk-copy:checked');
        for (i = 0, len = ref.length; i < len; i++) {
          elem = ref[i];
          elem = $(elem);
          elem.prop('checked', false);
          elem.closest('tr').find('.copy-btn').click();
        }
        return $(this).hide();
      });
      this.dialog.on('click.convert', '.chk-copy', (function(_this) {
        return function() {
          return _this.showHideButton();
        };
      })(this));
      this.dialog.on('click.convert', '.copy-btn', function() {
        var acres, chk, percent, pop, row;
        row = $(this).closest('tr');
        acres = row.find('.txt-actual-acres');
        pop = row.find('.txt-actual-pop');
        percent = row.find('.txt-actual-percent');
        if (!acres.val()) {
          acres.val(row.find('.txt-plan-acres').val());
        }
        if (!pop.val()) {
          pop.val(row.find('.txt-plan-pop').val());
        }
        if (!percent.val()) {
          percent.val(100);
        }
        percent.change();
        chk = row.find('.chk-copy');
        if (chk.is(':checked')) {
          chk.click();
          return ths.showHideButton();
        }
      });
      this.dialog.on('change.convert', '.txt-days', function() {
        var adj, days, days_adj, hrvstInput, plant, plant_txt;
        adj = $(this).val();
        plant_txt = $(this).closest('.actual-row').find('.txt-actual-date').val();
        days = $(this).closest('.actual-row').find('.days').val();
        plant = moment(plant_txt, "MM-DD-YYYY");
        adj = (adj != null) && adj !== '' && adj % 1 === 0 ? adj : 0;
        days = days != null ? days : 0;
        days_adj = parseInt(days) + parseInt(adj);
        plant.add(days_adj, "days");
        hrvstInput = $(this).closest('.actual-row').find('.hrvst_date');
        return hrvstInput.val(plant.format('MM/DD/YYYY'));
      });
      this.dialog.on('change.convert', '.txt-actual-percent', function() {
        var row, yld;
        row = $(this).closest('tr');
        yld = row.find('.txt-plan-yield').val() * $(this).val() / 100.0;
        return row.find('.txt-actual-yield').val(yld);
      });
      this.dialog.find('.save-btn').bind('click', (function(_this) {
        return function() {
          return _this.saveStub();
        };
      })(this));
      this.dialog.on('change', '.mfvalidate-invalid', function() {
        $(this).removeClass('mfvalidate-invalid');
        if (ths.dialog.find('.mfvalidate-invalid').length === 0) {
          return ths.dialog.find('.errorDiv').hide();
        }
      });
      this.dialog.find('.cancel-btn').bind('click', (function(_this) {
        return function() {
          var elem, i, len, ref, results;
          ref = _this.dialog.find('[data-orig]');
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            elem = ref[i];
            elem = $(elem);
            results.push(elem.val(elem.data('orig')));
          }
          return results;
        };
      })(this));
      return this.dialog.find('.export-btn').bind('click', (function(_this) {
        return function() {
          var url;
          if (_this.exportUrl == null) {
            _this.exportUrl = '';
          }
          url = _this.exportUrl + "?filters=" + ko.toJSON(_this.parent.getAppliedFilters());
          return window.open(url, '_blank');
        };
      })(this));
    };

    return Parent_Dialog_Handler;

  })(FullPageHandler);

}).call(this);
